import React, { useState } from 'react';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { AppLayout } from './components/layout/AppLayout';
import { LoginPage } from './pages/LoginPage';
import { AdminDashboard } from './pages/dashboard/AdminDashboard';
import { BranchDashboard } from './pages/dashboard/BranchDashboard';
import { BranchList } from './pages/branches/BranchList';
import { BranchForm } from './pages/branches/BranchForm';
import { UserList } from './pages/users/UserList';
import { UserForm } from './pages/users/UserForm';
import { PaymentBatchList } from './pages/payments/PaymentBatchList';
import { PaymentUpload } from './pages/payments/PaymentUpload';
import { CheckerReview } from './pages/payments/CheckerReview';
import { PostApprovalView } from './pages/payments/PostApprovalView';
import { ReportsPage } from './pages/reports/ReportsPage';
import { Toaster } from './components/ui/Toast';
function AppContent() {
  const {
    isAuthenticated,
    isAdmin,
    isChecker
  } = useAuth();
  const [currentPage, setCurrentPage] = useState('dashboard');
  const [viewState, setViewState] = useState<'list' | 'form' | 'detail'>('list');
  const [selectedBatchId, setSelectedBatchId] = useState<string | null>(null);
  if (!isAuthenticated) {
    return <LoginPage data-id="element-0" />;
  }
  const handleNavigate = (page: string) => {
    setCurrentPage(page);
    setViewState('list');
    setSelectedBatchId(null);
  };
  const handleViewBatch = (id: string) => {
    setSelectedBatchId(id);
    setViewState('detail');
  };
  const renderPage = () => {
    switch (currentPage) {
      case 'dashboard':
        return isAdmin ? <AdminDashboard data-id="element-1" /> : <BranchDashboard data-id="element-2" />;
      case 'branches':
        if (viewState === 'form') {
          return <BranchForm onCancel={() => setViewState('list')} onSubmit={() => setViewState('list')} data-id="element-3" />;
        }
        return <BranchList onAddBranch={() => setViewState('form')} data-id="element-4" />;
      case 'users':
        if (viewState === 'form') {
          return <UserForm onCancel={() => setViewState('list')} onSubmit={() => setViewState('list')} data-id="element-5" />;
        }
        return <UserList onAddUser={() => setViewState('form')} data-id="element-6" />;
      case 'payments':
        if (viewState === 'form') {
          return <PaymentUpload onComplete={() => setViewState('list')} onViewBatch={handleViewBatch} data-id="element-7" />;
        }
        if (viewState === 'detail' && selectedBatchId) {
          // If checker, show checker review. If maker/admin, show post-approval view (readonly)
          if (isChecker) {
            return <CheckerReview batchId={selectedBatchId} onBack={() => setViewState('list')} onComplete={() => setViewState('list')} data-id="element-8" />;
          }
          return <PostApprovalView batchId={selectedBatchId} onBack={() => setViewState('list')} data-id="element-9" />;
        }
        return <PaymentBatchList onNewBatch={() => setViewState('form')} onViewBatch={handleViewBatch} data-id="element-10" />;
      case 'reports':
        return <ReportsPage data-id="element-11" />;
      case 'audit':
        return <ReportsPage data-id="element-12" />;
      default:
        return isAdmin ? <AdminDashboard data-id="element-13" /> : <BranchDashboard data-id="element-14" />;
    }
  };
  const getPageTitle = () => {
    const titles: Record<string, string> = {
      dashboard: 'Dashboard',
      branches: 'Branch Management',
      users: 'User Management',
      payments: 'Payment Processing',
      reports: 'Reports & Analytics',
      audit: 'Audit Logs'
    };
    return titles[currentPage] || 'Dashboard';
  };
  return <AppLayout currentPage={currentPage} onNavigate={handleNavigate} title={getPageTitle()} data-id="element-15">
      {renderPage()}
      <Toaster data-id="element-16" />
    </AppLayout>;
}
export function App() {
  return <AuthProvider data-id="element-17">
      <AppContent data-id="element-18" />
    </AuthProvider>;
}